import { render, staticRenderFns } from "./SaveToLibraryPanel.vue?vue&type=template&id=6204c6bc"
import script from "./SaveToLibraryPanel.vue?vue&type=script&lang=js"
export * from "./SaveToLibraryPanel.vue?vue&type=script&lang=js"
import style0 from "./SaveToLibraryPanel.vue?vue&type=style&index=0&id=6204c6bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports